;(function () {
	'use strict';

	if (!customElements.get('recomendation-products')) {
		class RecomendationProducts extends HTMLElement {
			constructor() {
				super();
				this.viewport     = null;
				this.track        = null;
				this.slides       = [];
				this.pagination   = null;
				this.currentIndex = 0;
				this._active      = false;
			}

			connectedCallback() {
				this.viewport   = this.querySelector('.ab-rec-viewport');
				this.track      = this.querySelector('.ab-rec-track');
				this.slides     = Array.from(this.querySelectorAll('.ab-rec-slide'));
				this.pagination = this.querySelector('.ab-rec-pagination');

				if (!this.track || this.slides.length === 0) return;

				this.init();
				window.addEventListener('resize', () => this.init());

				this.track.addEventListener('scroll', () => this._onScroll(), { passive: true });
			}
		}

		RecomendationProducts.prototype.init = function () {
			if (window.innerWidth < 750) {
				if (!this._active) {
					this._buildPagination();
					this._active = true;
				}
				this._updateDots();
			} else {
				if (this._active) {
					this._destroyPagination();
					this._active = false;
					this.currentIndex = 0;
					this.track.scrollTo({ left: 0, behavior: 'instant' });
				}
			}
		};

		RecomendationProducts.prototype._buildPagination = function () {
			if (!this.pagination) return;
			this.pagination.innerHTML = '';
			this.slides.forEach((_, i) => {
				const dot = document.createElement('button');
				dot.className = 'ab-rec-dot' + (i === 0 ? ' active' : '');
				dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
				dot.addEventListener('click', () => {
					this.currentIndex = i;
					this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: 'smooth' });
					this._updateDots();
				});
				this.pagination.appendChild(dot);
			});
		};

		RecomendationProducts.prototype._destroyPagination = function () {
			if (this.pagination) this.pagination.innerHTML = '';
		};

		RecomendationProducts.prototype._onScroll = function () {
			if (!this._active) return;
			const scrollLeft = this.track.scrollLeft;
			let closest = 0;
			let minDiff  = Infinity;

			this.slides.forEach((slide, i) => {
				const diff = Math.abs(slide.offsetLeft - scrollLeft);
				if (diff < minDiff) { minDiff = diff; closest = i; }
			});

			this.currentIndex = closest;
			this._updateDots();
		};

		RecomendationProducts.prototype._updateDots = function () {
			if (!this.pagination) return;
			this.pagination.querySelectorAll('.ab-rec-dot').forEach((dot, i) => {
				dot.classList.toggle('active', i === this.currentIndex);
			});
		};

		customElements.define('recomendation-products', RecomendationProducts);
	}
})();
